var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321,0C320.4,0,191.6,0,191,0C132.7,0.5,85.3,48.2,85.3,106.6v298.7C85.3,464.1,133.2,512,192,512h128 c58.8,0,106.7-47.9,106.7-106.7V106.7C426.7,48.2,379.3,0.5,321,0z M384,405.3c0,35.3-28.7,64-64,64H192c-35.3,0-64-28.7-64-64 V106.7c0-31,22.1-56.9,51.4-62.8l14.8,29.6c3.6,7.2,11,11.8,19.1,11.8h85.3c8.1,0,15.5-4.6,19.1-11.8l14.8-29.6 c29.3,5.8,51.4,31.8,51.4,62.8V405.3L384,405.3z M277.3,426.6h-42.7c-11.8,0-21.3-9.6-21.3-21.3l0,0c0-11.8,9.6-21.3,21.3-21.3h42.7 c11.8,0,21.3,9.6,21.3,21.3l0,0C298.7,417.1,289.1,426.6,277.3,426.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall);
export default __webpack_public_path__ + "static/media/small.7c8e1f6de372d59a6a514f30f3725bdd.svg";
export { ForwardRef as ReactComponent };